import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ScrollToTopOnNavigate from '@/components/feature/ScrollToTopOnNavigate';
import { Link } from 'react-router-dom';
import { mangaList, categories } from '@/mocks/manga';

export default function HomePage() {
  const featuredManga = mangaList.filter((m) => m.featured);
  const hotManga = mangaList.filter((m) => m.hot).slice(0, 6);
  const latestManga = mangaList.filter((m) => m.latest).slice(0, 6);
  const popularCategories = categories.filter((c) => c.slug !== 'all').slice(0, 8);

  const homepageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '吹雪漫画网 - 免费无删减漫画在线阅读',
    description: '洞洞杂货铺免费读漫画全部，免费阅读无删减漫画下拉式。吹雪漫画网提供海量免费漫画，高清画质流畅阅读体验。',
    url: 'https://chuixue.com',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '吹雪漫画网',
      url: 'https://chuixue.com',
    },
  };

  return (
    <>
      <ScrollToTopOnNavigate />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageJsonLd) }} />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20manga%20reading%20atmosphere%20scene%2C%20cozy%20reading%20nook%20with%20warm%20amber%20lighting%2C%20floating%20manga%20pages%20and%20ink%20brush%20strokes%20in%20the%20air%2C%20traditional%20Japanese%20elements%20blended%20with%20modern%20cozy%20interior%2C%20soft%20golden%20hour%20warmth%2C%20dreamy%20artistic%20illustration%20style%2C%20rich%20textures%20and%20atmospheric%20depth&width=1920&height=900&seq=hero-bg-manga&orientation=landscape"
            alt="吹雪漫画网 - 免费漫画阅读"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 max-w-3xl leading-tight">
              <strong>洞洞杂货铺</strong>免费读漫画全部
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
              免费阅读无删减漫画下拉式，让您一次看个够。吹雪漫画网汇聚海量热门漫画资源，高清画质流畅阅读。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/article/dongdong-zahuopu"
                className="px-8 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
              >
                立即阅读洞洞杂货铺
              </Link>
              <Link
                to="/category/all"
                className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white font-medium rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm border border-white/30"
              >
                浏览全部漫画
              </Link>
            </div>
          </div>
        </section>

        {/* Featured Section */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                推荐漫画
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
              >
                查看更多 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {featuredManga.map((manga) => (
                <MangaCard key={manga.slug} manga={manga} />
              ))}
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6 text-center">
              漫画分类
            </h2>
            <div className="grid grid-cols-4 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
              {popularCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 transition-all duration-200 group cursor-pointer"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                    <i className={`${cat.icon} text-lg`}></i>
                  </span>
                  <span className="text-xs md:text-sm text-foreground-700 group-hover:text-primary-600 font-medium whitespace-nowrap transition-colors">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Manga */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                热门排行
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
              >
                查看更多 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {hotManga.map((manga, index) => (
                <div key={manga.slug} className="relative">
                  <span className="absolute top-2 left-2 z-10 w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 text-white text-xs font-bold">
                    {index + 1}
                  </span>
                  <MangaCard manga={manga} />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Updates */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                最近更新
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
              >
                查看更多 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {latestManga.map((manga) => (
                <MangaCard key={manga.slug} manga={manga} showUpdate />
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-accent-500">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              开启您的漫画之旅
            </h2>
            <p className="text-background-50/80 mb-8 text-sm md:text-base leading-relaxed">
              数千部漫画免费阅读，无删减、高清画质、下拉式流畅体验。每天都有新内容等您来发现！
            </p>
            <Link
              to="/category/all"
              className="inline-flex px-8 py-3 bg-background-50 text-accent-600 font-medium rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              立即开始阅读
            </Link>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}

function MangaCard({ manga, showUpdate }: { manga: typeof mangaList[0]; showUpdate?: boolean }) {
  return (
    <Link
      to={`/article/${manga.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg bg-background-200 aspect-[3/4] mb-2">
        <img
          src={manga.cover}
          alt={manga.title}
          title={`${manga.title} - 吹雪漫画网`}
          className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-2 right-2 px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-full">
          {manga.rating}
        </div>
        {manga.status === '连载中' && (
          <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
            {manga.status}
          </div>
        )}
        {manga.status !== '连载中' && (
          <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-foreground-600/70 text-white text-xs font-medium rounded-full">
            {manga.status}
          </div>
        )}
      </div>
      <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
        {manga.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-0.5">{manga.author}</p>
      {showUpdate && (
        <p className="text-xs text-accent-600 mt-0.5">更新至 {manga.chapters} 话</p>
      )}
    </Link>
  );
}